import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "../authentication/Auth";
import SiteRouter from './SiteRoute';

const RouteRestricter = (props) => {
  const {currentUser} = useContext(AuthContext);
  
  return (
    <Route
      render={routeProps =>
        !!currentUser ? (
            <SiteRouter />
        ) : (
          <Redirect to={"/login"} />
        )
      }
    />
  );
};


export default RouteRestricter;